import styled from 'styled-components';

const ListItem = styled.li`
  margin-bottom: 2rem;
  &::marker {
    font-weight: 400;
    font-size: 1.5rem;
  }
`;

export { ListItem };
